module.exports = __webpack_public_path__ + "static/media/Avatar6.78a4a699.png";